import { compose, id } from '@ally/utilitarian';
import { withDefaultHeaders, getContentType, getSanitizedHeaders, } from './general';
export var withAppHeaders = withDefaultHeaders({
    ApplicationId: 'ALLYUSBOLB',
    ApplicationName: 'AOB',
    ApplicationVersion: '1.0',
});
export var withApiKeyHeader = function (_a) {
    var apiKey = _a.apiKey;
    return withDefaultHeaders({ 'api-key': apiKey });
};
export var withCsrfToken = function (_a) {
    var session = _a.session;
    return session === null
        ? id
        : withDefaultHeaders({ CSRFChallengeToken: session.CSRFChallengeToken });
};
export var withAwsToken = function (_a) {
    var session = _a.session;
    return session === null
        ? id
        : withDefaultHeaders({
            Authorization: "Bearer " + session.AwsAccessToken,
        });
};
export var withContentType = withDefaultHeaders(compose(getSanitizedHeaders, function (contentType) {
    if (contentType === void 0) { contentType = ''; }
    return ({ 'Content-Type': contentType });
}, getContentType));
//# sourceMappingURL=request.js.map